export default "__VITE_ASSET__5aebb042__"